import { axiosPost } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function CreateNewPastEdition({ setBtnLoading, btnLoading, editionNumber,
    eventDate, eventLocation }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            var response = await axiosPost({
                endpoint: ApiConstants.CREATE_PAST_EDITION,
                jsonBody: JSON.stringify({
                    editionNumber: editionNumber,
                    eventDate: eventDate,
                    eventLocation: eventLocation
                })
            })

            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default CreateNewPastEdition;